export default __webpack_public_path__ + "static/media/cage.02d998c3.jpg";